module.exports = __webpack_public_path__ + "static/media/lease2_img2.7fa51635.jpg";